/**
 * detectLayout — Determine whether the current device is mobile or desktop.
 *
 * Uses CSS media queries only — no User-Agent sniffing.
 * Tablets (iPad, Surface in tablet mode) always resolve to 'mobile', ensuring
 * they receive the full experience instead of the QR handoff screen.
 *
 * Logic:
 *   - pointer: coarse  (touch screen)  → mobile
 *   - width < 1024px                   → mobile
 *   - else (fine pointer + wide)       → desktop
 *
 * @see docs/ims-brand-frontends/03-design-system.md#device-detection-kein-user-agent-sniffing
 */
export function detectLayout(): 'mobile' | 'desktop' {
  const isTouch = window.matchMedia('(pointer: coarse)').matches;
  if (isTouch) return 'mobile';

  const isNarrow = window.matchMedia('(max-width: 1023px)').matches;
  if (isNarrow) return 'mobile';

  return 'desktop';
}
